import { useCallback } from 'react';
import { useAppStore } from '@store/app.store';
import { useSkywardsSettings } from '@shared/components/Layout/Header/useSkywardsSettings';

export interface WebSessionActionPopupHandlers {
  handleClose: () => void;
  handleContinue: () => void;
  handleCancel: () => void;
}

export const useWebSessionActionPopup = (): WebSessionActionPopupHandlers => {
  const setLoadingError = useAppStore((state) => state.setLoadingError);
  const { homepageUrl } = useSkywardsSettings();
  const triggerWebSessionSelectPaxRetry = useAppStore(
    (state) => state.triggerWebSessionSelectPaxRetry,
  );

  const handleClose = useCallback((): void => {
    setLoadingError({ cmsKey: null, hasError: false, errorMessage: null });
    if (homepageUrl) {
      window.location.href = homepageUrl;
    }
  }, [homepageUrl, setLoadingError]);

  const handleCancel = useCallback((): void => {
    setLoadingError({ cmsKey: null, hasError: false, errorMessage: null });
  }, [setLoadingError]);

  const handleContinue = useCallback((): void => {
    triggerWebSessionSelectPaxRetry();
    setLoadingError({ cmsKey: null, hasError: false, errorMessage: null });
  }, [setLoadingError, triggerWebSessionSelectPaxRetry]);

  return {
    handleClose,
    handleContinue,
    handleCancel,
  };
};
